<template>
  <!--<div>-->
    <div class="page-content">
      <div class="inner" v-if="contentsPrice != null && contentsOverview != null">
        <div class="card-contents">
          <div class="flexcenter">
            <div class="cover-image"><img :src="getContentsThumbnailPath(contentsDetail.contentid, showScreen) " :alt="contentsDetail.content_name"></div>
            <div class="detail-content">
              <div class="flexbetween">
                <div class="content-name font28">{{ contentsDetail.content_name }}</div>
                <div class="price" v-if="contentsPrice != '0'"><span>税込</span><span class="font20">{{ contentsPrice }}</span>円</div>
              </div>
              <div class="content">
                <p>{{ contentsOverview }}</p>
              </div>
              <div class="content-button">
                <button @click="buyContents">購入する</button>
              </div>
            </div><!-- detail-content -->
          </div><!-- flexcenter -->
        </div><!-- card-contents -->
      </div><!-- inner -->
      <!-- 詳細表示前 -->
      <div class="inner" v-else />
    </div><!-- page-content -->
  <!--</div>-->
</template>

<script>
import common from '@/mixin/common';
import * as constants from '@/mixin/constants';

export default {
  name: 'storeDetail',
  mixins: [
    common,
  ],
  data: function () {
    return {
      contentsOverview: null,
      contentsPrice: null,
      productId: '',
      showScreen: 'StoreDetail',
    }
  },
  computed: {
    isMobile: () => window.hasOwnProperty(constants.MOBILE_INTERFACE_NAME),
  },
  props: {
    contentsDetail: Object,
  },
  created: async function () {
    this.log("StoreDetail start created");
    this.log("isMobile: " + this.isMobile);

    this.contentsOverview = await this.getTextFileData(this.getContentsOverviewPath(this.contentsDetail.contentid));
    if (this.isMobile) {
      // ツールバーにタイトル設定
      this.$emit('setViewName', 'ストア');
      // モバイルアプリコールバック設定
      ROSETTA_onErrorAccessKey = this.ROSETTA_onErrorAccessKey;
      ROSETTA_onContentPrice = this.ROSETTA_onContentPrice;
      ROSETTA_onBuyContentComplete = this.ROSETTA_onBuyContentComplete;
      // プロダクトID取得
      this.productId = this.getProductId();

      window.Phone.GetContentPrice(this.productId);
    } else {
      this.contentsPrice = this.getFormattedPrice(this.contentsDetail.ecprice);
    }
  },
  mounted: function() {
    this.log("StoreDetail start mounted");
  },
  methods: {
    /**
     * プロダクトID取得処理
     */
    getProductId: function () {
      this.log("StoreDetail start getProductId");
      var mobilePlatformName = window.Phone.GetPlatformName();
      this.log("MobilePlatformName: " + mobilePlatformName);
      switch (mobilePlatformName) {
        case constants.PLATFORM_ANDROID:
          return this.contentsDetail.productid_playstore;
        case constants.PLATFORM_IOS:
          return this.contentsDetail.productid_appstore;
        default:
          return null;
      }
    },
    /**
     * フォーマットされた価格を取得する
     *
     * @param {String} price フォーマット前の価格
     * @return {String} フォーマット後の価格
     */
    getFormattedPrice: function (price) {
      // 数字以外除去
      var result = Number(String(price).replace(/[^0-9.]/g, ""));
      // カンマ付きで返す
      return String(result).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    },
    /**
     * コンテンツ購入処理
     */
    buyContents: function () {
      this.log("StoreDetail start buyContents");
      this.log("isMobile: " + this.isMobile);
      if (this.isMobile) {
        this.buyContentsMobile();
      } else {
        this.showEcSite();
      }
    },
    /**
     * モバイルアプリコンテンツ購入処理
     */
    buyContentsMobile: async function () {
      this.log("StoreDetail start buyContentsMobile");
      window.Phone.BuyContent(this.productId, await storage_wrapper.getRsAccessKey());
    },
    /**
     * ECサイト表示処理
     */
    showEcSite: function () {
      var url = this.contentsDetail.ecurl;
      this.log("StoreDetail start showEcSite url: " + url);
      window.open(url);
    },
    /**
     * アクセスキー無効エラーダイアログ表示
     */
    showErrorInvalidAccessKey: function () {
      var message = "INFO_INVALID_ACCESSKEY";
      var buttonKind = constants.ERROR_BUTTON_KIND_LOGIN;
      this.$emit('showError', message, buttonKind);
    },
    /**
     * モバイルアプリコールバック：アクセスキー無効エラー発生
     */
    ROSETTA_onErrorAccessKey: function () {
      this.log("ROSETTA_onErrorAccessKey start");
      this.showErrorInvalidAccessKey();
    },
    /**
     * モバイルアプリコールバック：コンテンツ価格取得
     *
     * @param {String} price コンテンツ価格
     */
    ROSETTA_onContentPrice: function (price) {
      this.log("ROSETTA_onContentPrice start price: " + price);
      this.contentsPrice = this.getFormattedPrice(price);
    },
    /**
     * モバイルアプリコールバック：コンテンツ購入処理完了
     *
     * @param {String} productId プロダクトID
     */
    ROSETTA_onBuyContentComplete: function (productId) {
      this.log("ROSETTA_onBuyContentComplete start productId: " + productId);
      this.$emit('changeView', 'StoreList');
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/style/common';
@import 'src/assets/style/store';
</style>



// WEBPACK FOOTER //
// StoreDetail.vue?992660f6